<template>
  <div>
    <v-data-table :headers="headers" :items="tokens" :disable-initial-sort="true"
                  :pagination="pagination" @update:pagination="setPagination">
      <template slot="items" slot-scope="token">
        <td class="text-xs-left">{{ token.item.jti }}</td>
        <td class="text-xs-left">{{ formatDate(token.item.expiry) }}</td>
        <td class="text-xs-center">
          <v-btn small @click="openModalForToken(token.item.granted)">View scopes</v-btn>
        </td>
        <td>
          <v-btn v-if="token.item.note" icon @click="openNote(token.item.note)">
            <v-icon>notes</v-icon>
          </v-btn>
          <!--<v-btn v-if="canManage" icon>--><!-- TODO [#7636] add revocation -->
          <!--<v-icon color="error">delete</v-icon>-->
          <!--</v-btn>-->
        </td>
      </template>
      <template slot="actions">
        <div v-if="isSingletonView" class="push-left">
          <v-btn flat to="/tokens" exact>
            <v-icon>arrow_back</v-icon>
            All tokens
          </v-btn>
        </div>
        <v-layout row v-else>
          <v-flex xs6 v-if="canManage">
            <v-subheader>
              Create token
              <v-btn to="/tokens/new" icon>
                <v-icon color="success">add_box</v-icon>
              </v-btn>
            </v-subheader>
          </v-flex>
          <v-flex xs6 class="action-checkbox text-xs-right">
            <v-checkbox v-model="expired" label="Expired"/>
          </v-flex>
        </v-layout>
      </template>
    </v-data-table>
    <v-dialog v-model="showNote" width="500px">
      <v-card>
        <v-card-text>
          <div class="pre">
            {{ note }}
          </div>
          <v-btn @click="showNote = false">Close</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showToken" width="500px">
      <v-card class="services-padded">
        <p class="pre">
          <yaml-representation :value="tokenToShow"/>
        </p>
        <v-btn @click="showToken = false">Close</v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import YamlRepresentation from '@/views/shared/yaml/YamlRepresentation';

  export default {
    props: ['jti'],
    components: { YamlRepresentation },
    data() {
      return {
        headers: [
          { text: 'JTI', value: 'jti', align: 'left' },
          { text: 'Expires', value: 'expiry', align: 'left' },
          { text: 'Scopes', value: 'permissions', align: 'left', sortable: false },
          { text: '', align: 'right', sortable: false }
        ],
        expired: false,
        tokens: [],
        showNote: false,
        note: null,
        showToken: false,
        tokenToShow: {}
      };
    },
    computed: {
      isSingletonView() {
        return this.jti && this.jti.length;
      },
      canManage() {
        return this.$auth.hasPermission('MANAGE_TOKENS');
      },
      ...mapState('tokens', [
        'pagination'
      ])
    },
    watch: {
      jti() {
        this.getTokens();
      },
      expired() {
        this.getTokens();
      }
    },
    mounted() {
      this.getTokens();
    },
    methods: {
      getTokens() {
        const params = {};
        if (this.jti) {
          params.jti = this.jti;
        } else if (this.expired) {
          params.include = 'expired';
        }

        return this.$services.authenticator.get('/tokens', {
          params
        }).then((res) => this.tokens = res.data.data)
          .catch(this.$defaultHandlerHttp);
      },
      formatDate(ts) {
        if (ts > 0) {
          return new Date(ts * 1000).toLocaleDateString('en-AU');
        }
        return '';
      },
      openNote(note) {
        this.note = note;
        this.showNote = true;
      },
      openModalForToken(token) {
        this.showToken = true;
        this.tokenToShow = token;
      },
      ...mapActions('tokens', [
        'setPagination'
      ])
    }
  };
</script>

<style lang="less" scoped>
  @import '../../style/text.less';

  .push-left {
    margin-right: auto;
  }

  .action-checkbox {
    padding-top: 8px;
    padding-left: 15px;
  }

  .pre {
    padding: 20px 5px;
    margin: 10px;
  }

  .services-padded {
    padding: 30px;
    .pre {
      margin: 0 0 15px 0;
    }
  }
</style>
